import { Flex } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

import { VoucherIcon } from './icons';

interface VoucherAvailableBadgeProps {
  label?: string;
  size?: 'md' | 'sm';
}

export function VoucherAvailableBadge({
  label = 'Voucher tersedia',
  size = 'md',
}: VoucherAvailableBadgeProps) {
  const isSmall = size === 'sm';

  return (
    <Flex
      display="inline-flex"
      align="center"
      gap={isSmall ? '1' : '1.25'}
      h={isSmall ? '20px' : '28px'}
      px={isSmall ? '1' : '2.5'}
      borderRadius={isSmall ? '4px' : '6px'}
      bg="#F2F5FF"
      color="#0000A3"
      maxW="fit-content"
      whiteSpace="nowrap"
    >
      <VoucherIcon
        w={isSmall ? '20px' : '14px'}
        h={isSmall ? '20px' : '14px'}
        minW={isSmall ? '20px' : '14px'}
      />
      <Text color="inherit" fontSize={isSmall ? '10px' : 'xs'} fontWeight="500">
        {label}
      </Text>
    </Flex>
  );
}
